
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconOpenTab } from 'components/Icon/IconOpenTab'
import { MyDrawer, DrawerCloseReason } from 'components/MyDrawer/MyDrawer'
import { MyLink } from 'components/MyLink'

export interface AccountSettingsUpdateNameAndAddressProps {
  onClose: (reason: DrawerCloseReason) => void
  isRRB?: boolean
}

export const AccountSettingsUpdateNameAndAddress: React.FC<AccountSettingsUpdateNameAndAddressProps> = ({ onClose, isRRB }) => {
  const { t } = useTranslation('accountSettings')

  const openTabIcon = (
    <IconOpenTab
      className='ds-u-display--inline-block my-u-m--2'
      srText={t('drawer.openPageSrText')}
    />
  )

  return (
    <MyDrawer
      containerId='medicare-my-acct-name-address'
      heading={t('drawer.heading1')}
      onClose={onClose}
      eventNamespace="accountSettings"
      openEventKey={isRRB ? 'accountsettings_rrbupdatenameoraddress_opendrawer' : 'accountsettings_ssupdatenameoraddress_opendrawer'}
      closeEventKey={isRRB ? 'accountsettings_rrbpdatenameoraddress_closedrawer' : 'accountsettings_ssupdatenameoraddress_closedrawer'}
    >
      {isRRB
        ? (
      <div>
        <p>{t('drawer.rrb.paragraph')}</p>
        <div>
          <ul className='my-u-ul-spacing'>
            <li>
              <MyLink
                href="https://rrb.gov/Benefits/myRRB"
                target='_blank'
                rel="noopener noreferrer"
                siteActivityProps={{
                  core: {
                    component: 'Account Settings',
                    elementId: 'accountsettings_drawerrrbupdatenameoraddress_click',
                    coreClickData: {
                      linkText: t('drawer.rrb.li1.linkText'),
                      linkUrl: 'https://rrb.gov/Benefits/myRRB'
                    }
                  }
                }}>{t('drawer.rrb.li1.linkText')}{openTabIcon}</MyLink>
              {t('drawer.rrb.li1.text')}
            </li>
            <li>{t('drawer.rrb.li2.text')}<br/>{t('drawer.rrb.li2.text2')}<br/>{t('drawer.rrb.li2.text3')}</li>
            <li>
              <MyLink
                href="https://rrb.gov/Field-Office-Locator"
                target='_blank'
                rel="noopener noreferrer"
                siteActivityProps={{
                  core: {
                    component: 'Account Settings',
                    elementId: 'accountsettings_drawerrrbofficefinder_click',
                    coreClickData: {
                      linkText: t('drawer.rrb.li3.linkText'),
                      linkUrl: 'https://rrb.gov/Field-Office-Locator'
                    }
                  }
                }}>{t('drawer.rrb.li3.linkText')}{openTabIcon}</MyLink>
              {t('drawer.rrb.li3.text')}
            </li>
          </ul>
        </div>
      </div>
          )
        : (
        <div>
          <p>{t('drawer.ssa.paragraph')}</p>
          <ul>
            <li>
              <MyLink
                href="https://www.ssa.gov/myaccount/"
                target='_blank'
                rel="noopener noreferrer"
                siteActivityProps={{
                  core: {
                    component: 'Account Settings',
                    elementId: 'accountsettings_drawerssupdatenameoraddress_click',
                    coreClickData: {
                      linkText: t('drawer.ssa.li1.linkText'),
                      linkUrl: 'https://www.ssa.gov/myaccount/'
                    }
                  }
                }}>{t('drawer.ssa.li1.linkText')}{openTabIcon}
                </MyLink>
              {t('drawer.ssa.li1.text')}
            </li>
            <li>{t('drawer.ssa.li2.text')}<br/>{t('drawer.ssa.li2.text2')}</li>
            <li>
              <MyLink
                href="https://www.ssa.gov/locator/"
                target='_blank'
                rel="noopener noreferrer"
                siteActivityProps={{
                  core: {
                    component: 'Account Settings',
                    elementId: 'accountsettings_drawerssofficefinder_click',
                    coreClickData: {
                      linkText: t('drawer.ssa.li3.linkText'),
                      linkUrl: 'https://www.ssa.gov/myaccount/'
                    }
                  }
                }}
              >{t('drawer.ssa.li3.linkText')}{openTabIcon}</MyLink>
              {t('drawer.ssa.li3.text')}
            </li>
          </ul>
        </div>
          )}
    </MyDrawer>
  )
}
